import { styled } from '@mui/material/styles';

import { styleConfigs } from '../../../components/resources/styleConfigs';
import BoxWrapper from '../../../components/wrappers/BoxWrapper';
import LinkWrapper from '../../../components/wrappers/LinkWrapper';
import useGetPaletteFromWhiteLabel from '../../../hooks/useGetPaletteFromWhiteLabel';
import palette from '../../../theme/learnerPalette';

export const ProfileContainer = styled('div')(() => ({
  display: 'flex',
}));

export const ProfileDetails = styled('div')(() => ({
  width: styleConfigs.dimensions.percent100,
}));

export const EmptyMajorsLinkStyled = styled(LinkWrapper)(() => ({
  fontSize: styleConfigs.fonts.sizeCustom12,
  color: palette.light.text.yaleBlue,
}));

export const BoxAvatar = styled(BoxWrapper)(() => {
  const wlPalette = useGetPaletteFromWhiteLabel();
  const backgroundColor = wlPalette?.primary?.main ?? palette.light.background.redViolet;

  return {
    width: styleConfigs.dimensions.width108,
    height: styleConfigs.dimensions.height110,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: backgroundColor,
    borderRadius: styleConfigs.borders.extraSmall,
  };
});
